export const iconFontAwesomeConnectivityEthernet = (
	<i className="fa-solid fa-ethernet"></i>
);
